module.exports = __webpack_public_path__ + "img/forgot-password.d5620417.png";